import React from 'react'
import { motion } from 'framer-motion'
import { Button } from "../components/ui/button"
import { X } from 'lucide-react'

export default function DeleteReviewPopup({ onConfirm, onCancel }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm" onClick={onCancel} />
      <motion.div
        initial={{ scale: 0.95, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.95, opacity: 0 }}
        className="bg-white rounded-lg p-6 w-full max-w-md mx-4 relative z-10"
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Delete Review</h2>
          <Button variant="ghost" size="icon" onClick={onCancel}>
            <X className="h-5 w-5" />
          </Button>
        </div>
        <p className="text-gray-600 mb-6">
          Are you sure you want to delete this review? This action cannot be undone.
        </p>
        <div className="flex justify-end gap-3">
          <Button variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onConfirm}>
            Delete
          </Button>
        </div>
      </motion.div>
    </div>
  )
}

